/**
 * Naformátuje cenu tak aby bola zobraziteľná pre používateľa
 *
 * Vstupná hodnota musí byť celé číslo.
 */
export function formatIntPrice(value: number): string {
  return (new Intl.NumberFormat('sk-SK', {
    style: 'decimal',
    minimumFractionDigits: 2
  })).format(value / 100)
}

/**
 * Naformátuje cenu tak aby bola zobraziteľná pre používateľa
 *
 * Vstupná hodnota musí byť celé číslo.
 */
export function formatFloatPrice(value: number): string {
  return (new Intl.NumberFormat('sk-SK', {
    style: 'decimal',
    minimumFractionDigits: 2
  })).format(value)
}

/**
 * Naformátuje bankový kód stravníka (variabilný symbol) na zobrazenie
 */
export function formatBoarderBankIdentificationCode(bankIdentificationCode: number): string {
  return bankIdentificationCode.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ' ')
}

/**
 * Naformátuje IBAN na zobrazenie
 */
export function formatIban(iban: string): string {
  return iban
    .replace(/\s\s+/g, ' ')
    .replace(/\S{4}(?=.)/g, '$& ')
}
